export default {
  formId: "UltiproConfiguration",
  formField: {
    url: {
      name: "url",
      label: "Simplitime Url",
      type: "text",
      errorMsg: "URL is required.",
      invalidMsg: "URL is invalid",
    },
    domain: {
      name: "domain",
      label: "Simplitime Domain",
      type: "text",
      errorMsg: "Domain is required.",
      invalidMsg: "Domain is invalid",
    },
    apiKey: {
      name: "apiKey",
      label: "Api-Key",
      type: "text",
      errorMsg: "Api key is required.",
      invalidMsg: "Api key is invalid",
    },
  },
};
